import React, { useEffect } from "react";
import { Link, useHistory, useLocation } from "react-router-dom";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import axios from "axios";
import toast, { Toaster } from "react-hot-toast";
import useOnceEffect from "../Hooks/useOnceEffect";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

function UpdatePassword() {
  const history = useHistory();

  let query = useQuery();

  useOnceEffect(() => {
    if (query.get("token") === "invalid" || query.get("token") === null) {
      toast.error("Token ivalido, favor ingrese su correo nuevamente", {
        duration: 4000,
      });
      setTimeout(function () {
        history.push("/ResetPassword");
      }, 5000);
    }
  });

  function postUpdatePassword(values, setFieldError) {
    axios
      .post("auth/update-password", {
        password: values.password,
        token: query.get("token"),
      })
      .then((result) => {
        if (result.status === 200) {
          localStorage.clear();
          toast.success(result.data.message, {
            duration: 4000,
          });
          history.push("/login");
          
        }
      })
      .catch(function (error) {
        toast.dismiss();
        if (error.response.status === 400) {
          toast.error(error.response.data.errors[0].defaultMessage);
          setFieldError(
            error.response.data.errors[0].field,
            error.response.data.errors[0].defaultMessage
          );
        }
        if (error.response.status === 406) {
          toast.error(error.response.data.message);
          setFieldError(error.response.data.field, error.response.data.message);
        }
      });
  }

  const Validaciones = Yup.object().shape({
    password: Yup.string()
      .required("No puede estar vacio")
      .oneOf(
        [Yup.ref("confirmpassword"), null],
        "Las contrasenas no coinciden"
      ),
    confirmpassword: Yup.string()
      .required("No puede estar vacio")
      .oneOf([Yup.ref("password"), null], "Las contrasenas no coinciden"),
  });

  function mostrarPassword() {
    var cambio = document.getElementById("password");
    cambio.type == "password"
      ? (cambio.type = "text")
      : (cambio.type = "password");
  }

  return (
    <div className="login">
      <Toaster />
      <div className="container">
        <div className="row">
          <div className="col-sm-12 align-div--middle">
            <div className="login__content-wrapper">
              <div className="logo">KREZCO</div>
              <div className="form form--login form--white form--bordered">
                <Formik
                  initialValues={{
                    password: "",
                    confirmpassword: "",
                  }}
                  onSubmit={(values, { setFieldError, setSubmitting }) => {
                    setSubmitting(true);
                    postUpdatePassword(values, setFieldError);
                    setSubmitting(false);
                  }}
                  validationSchema={Validaciones}
                >
                  {({ errors, touched, isSubmitting }) => (
                    <Form>
                      <div className="form__wrapper">
                        <div className="form__title text-center">
                          Ingresa tu nueva contraseña
                        </div>
                        <div className="form__row">
                          <label htmlFor="password">Contraseña</label>
                          <Field
                            type="password"
                            name="password"
                            id="password"
                            required
                          ></Field>
                          <i
                            class="fa fa-eye-slash password-icon"
                            onClick={mostrarPassword}
                          />
                          {errors.password && touched.password && (
                            <span className="form__validation form__validation--error">
                              {errors.password}
                            </span>
                          )}
                        </div>
                        <div className="form__row">
                          <label htmlFor="password">Confirmar Contraseña</label>
                          <Field
                            type="password"
                            name="confirmpassword"
                            id="confirmpassword"
                            required
                          ></Field>
                          {errors.confirmpassword &&
                            touched.confirmpassword && (
                              <span className="form__validation form__validation--error">
                                {errors.confirmpassword}
                              </span>
                            )}
                        </div>

                        <div className="form__row">
                          <button
                            disabled={isSubmitting}
                            type="submit"
                            className="btn btn--gradient btn__icon btn__icon--door"
                          >
                            <i className="fas fa-paper-plane"></i> Aceptar
                          </button>
                        </div>
                      </div>
                    </Form>
                  )}
                </Formik>
              </div>
              <div className="regular-content text-color--white text-center pt-4">
                ¿Aún no tienes una cuenta?{" "}
                <Link to="/Registrate" className="link-color--purple">
                  Forma parte de la comunidad KREZCO
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default UpdatePassword;
